module.exports = __webpack_public_path__ + "img/SCC_Mono.Macro.df603a64.png";